import { render, staticRenderFns } from "./EndpointCard.vue?vue&type=template&id=74a84f2f&scoped=true"
import script from "./EndpointCard.vue?vue&type=script&lang=js"
export * from "./EndpointCard.vue?vue&type=script&lang=js"
import style0 from "./EndpointCard.vue?vue&type=style&index=0&id=74a84f2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a84f2f",
  null
  
)

export default component.exports